import React from 'react';

const Hero = () => (
  <div className='privacy-hero'>
    <div className='container mx-auto pt-24 lg:pt-32 pb-16 px-8'>
      <div className='lg:w-2/5'>
        <h1 className='font-sans font-bold text-white text-4xl lg:text-5xl leading-very-tight mb-4'>
          Privacy Policy
        </h1>
      </div>
    </div>
  </div>
);

export default Hero;
